import { useQuery } from '@tanstack/react-query';
import { getAccountsConfigurations } from '../requests';
import { useSessionStore } from '@/entities/session';
import { useAppSettingsStore } from '@/shared/lib';
import { accountsKeys } from '../keys';

const useAccountsConfigurations = () => {
  const { session } = useSessionStore();
  const { getLanguage } = useAppSettingsStore();

  const { data, isLoading, error, isError } = useQuery({
    queryKey: [
      accountsKeys.configurations,
      session?.userId,
      session?.accessExpiresTo,
      getLanguage(),
    ],
    queryFn: getAccountsConfigurations,
    enabled: !!session?.userId,
    staleTime: Infinity,
  });

  return {
    accountsConfigurations: data,
    isAccountsConfigurationsLoading: isLoading,
    accountsConfigurationsError: error,
    isAccountsConfigurationsError: isError,
  };
};

export { useAccountsConfigurations };
